<ng-container *transloco="let t">
    <form
        [formGroup]="background"
        #ngForm="ngForm"
        fxLayout="column"
        (ngSubmit)="onSubmit($event)"
    >
        <!-- ETHNICITY -->
        <div class="flyout-container" *ngIf="ethnicitySelectionId">
            <app-single-selection-control
                *ngIf="ethnicitySelections$ | async as ethnicitySelections"
                [formGroup]="background"
                [selections]="ethnicitySelections"
                [control]="ethnicitySelectionId"
                formControlName="ethnicitySelectionId"
                [header]="t('shared.group.ethnicity')"
                [label]="t('shared.radio-checkbox-group.ethnicity')"
                [requiredMessage]="t('shared.error.required.ethnicity')"
                [formSubmitted]="ngForm.submitted"
            ></app-single-selection-control>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.ethnicity').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container *ngFor="let trans of t('flyout.ethnicity')">
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- RACE -->
        <div class="flyout-container" *ngIf="raceSelectionIds">
            <app-multi-selection-control
                *ngIf="raceSelections$ | async as raceSelections"
                [formGroup]="background"
                [selections]="raceSelections"
                [control]="raceSelectionIds"
                formControlName="raceSelectionIds"
                [header]="t('shared.group.race')"
                [label]="t('shared.radio-checkbox-group.race')"
                [requiredMessage]="t('shared.error.required.race')"
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.race').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container *ngFor="let trans of t('flyout.race')">
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- COUNTRY OF BIRTH -->
        <div *ngIf="countryOfBirthSelectionId">
            <h3>{{ t("shared.group.country-of-birth") }}</h3>
            <h4>
                {{ t("shared.radio-checkbox-group.country-of-birth") }}
            </h4>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            countryOfBirthSelections$
                                | async as countryOfBirthSelections
                        "
                    >
                        <mat-label>{{
                            t("shared.field.country-of-birth")
                        }}</mat-label>
                        <mat-select
                            formControlName="countryOfBirthSelectionId"
                            [required]="
                                countryOfBirthSelectionId.hasError('required')
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let countryOfBirthSelection of countryOfBirthSelections
                                "
                                [value]="countryOfBirthSelection.selectionId"
                            >
                                {{ countryOfBirthSelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                countryOfBirthSelectionId?.hasError('required')
                            "
                        >
                            {{ t("shared.error.required.country-of-birth") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- US CITIZEN -->
        <div *ngIf="citizenshipStatusSelectionId">
            <app-single-selection-control
                *ngIf="
                    citizenshipStatusSelections$
                        | async as citizenshipStatusSelections
                "
                [formGroup]="background"
                [selections]="citizenshipStatusSelections"
                [control]="citizenshipStatusSelectionId"
                formControlName="citizenshipStatusSelectionId"
                [label]="t('shared.radio-checkbox-group.citizenship')"
                [requiredMessage]="t('shared.error.required.citizenship')"
                [formSubmitted]="ngForm.submitted"
            ></app-single-selection-control>
        </div>

        <!-- BARRIERS TO EMPLOYMENT -->
        <div class="flyout-container" *ngIf="barrierSelectionIds">
            <mat-divider></mat-divider>

            <app-multi-selection-control
                *ngIf="barriersSelections$ | async as barriersSelections"
                [formGroup]="background"
                [selections]="barriersSelections"
                [control]="barrierSelectionIds"
                formControlName="barrierSelectionIds"
                [header]="t('shared.group.barrier-to-employment')"
                [label]="t('shared.radio-checkbox-group.barrier-to-employment')"
                [requiredMessage]="
                    t('shared.error.required.barriers-to-employment')
                "
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>

            <p
                *ngIf="client$ | async as client"
                [innerHTML]="client.barriersToEmploymentHtml"
            ></p>

            <div *ngIf="disabilityYesNoSelectionId">
                <app-single-selection-control
                    *ngIf="
                        disabilityYesNoSelections$
                            | async as disabilityYesNoSelections
                    "
                    [formGroup]="background"
                    [selections]="disabilityYesNoSelections"
                    [control]="disabilityYesNoSelectionId"
                    formControlName="disabilityYesNoSelectionId"
                    [label]="t('shared.radio-checkbox-group.disability-yes-no')"
                    [requiredMessage]="
                        t('shared.error.required.disability-yes-no')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div *ngIf="disabilityAssistanceSelectionId">
                <app-single-selection-control
                    *ngIf="
                        disabilityAssistanceYesNoSelections$
                            | async as disabilityAssistanceYesNoSelections
                    "
                    [formGroup]="background"
                    [selections]="disabilityAssistanceYesNoSelections"
                    [control]="disabilityAssistanceSelectionId"
                    formControlName="disabilityAssistanceSelectionId"
                    [label]="
                        t('shared.radio-checkbox-group.disability-assistance')
                    "
                    [requiredMessage]="
                        t('shared.error.required.disability-assistance')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div
                *ngIf="homelessSite"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <!-- HOMELESS SITE -->
                <div
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>
                            {{ t("shared.field.homeless-site") }}
                        </mat-label>
                        <input
                            matInput
                            formControlName="homelessSite"
                            [autocomplete]="'homelessSite' | autocomplete"
                            maxlength="200"
                            [required]="homelessSite.hasError('required')"
                        />
                        <mat-error *ngIf="homelessSite?.hasError('required')">
                            {{ t("shared.error.required.homeless-site") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- CORRECTIONS STATUS -->
            <div *ngIf="correctionsStatusSelectionId">
                <app-single-selection-control
                    *ngIf="
                        correctionsStatusSelections$
                            | async as correctionsStatusSelections
                    "
                    [formGroup]="background"
                    [selections]="correctionsStatusSelections"
                    [control]="correctionsStatusSelectionId"
                    formControlName="correctionsStatusSelectionId"
                    [label]="t('shared.radio-checkbox-group.corrections')"
                    [requiredMessage]="t('shared.error.required.corrections')"
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- Display custom Barriers to Employment help for CT -->
            <!-- NOTE: This is NOT a recommended pattern for making client
            specific customizations. If we need to make additional 
            customizations to the help for specific clients, we should
            consider refactoring this. Perhaps storing this content in the 
            database. -->
            <mat-card
                appearance="outlined"
                *ngIf="clientCode === 'ct'"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.barrier-to-employment-ct').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="
                            let trans of t('flyout.barrier-to-employment-ct')
                        "
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
            <mat-card
                appearance="outlined"
                *ngIf="clientCode !== 'ct'"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.barrier-to-employment').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.barrier-to-employment')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- MILITARY SERVICE -->
        <div
            class="flyout-container"
            *ngIf="
                veteranSelectionId ||
                militaryServiceExperienceSelectionId ||
                selectiveServiceNotificationSelectionId
            "
        >
            <mat-divider></mat-divider>
            <h3>{{ t("shared.group.military-service") }}</h3>

            <div *ngIf="veteranSelectionId">
                <app-single-selection-control
                    *ngIf="veteranSelections$ | async as veteranSelections"
                    [formGroup]="background"
                    [selections]="veteranSelections"
                    [control]="veteranSelectionId"
                    formControlName="veteranSelectionId"
                    [label]="t('shared.radio-checkbox-group.veteran')"
                    [requiredMessage]="t('shared.error.required.veteran')"
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div *ngIf="militaryServiceExperienceSelectionId">
                <app-single-selection-control
                    *ngIf="
                        militaryServiceExperienceSelections$
                            | async as militaryServiceExperienceSelections
                    "
                    [formGroup]="background"
                    [selections]="militaryServiceExperienceSelections"
                    [control]="militaryServiceExperienceSelectionId"
                    formControlName="militaryServiceExperienceSelectionId"
                    [label]="t('shared.radio-checkbox-group.military-service')"
                    [requiredMessage]="
                        t('shared.error.required.military-service')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div *ngIf="selectiveServiceNotificationSelectionId">
                <app-single-selection-control
                    *ngIf="
                        selectiveServiceNotificationSelections$
                            | async as selectiveServiceNotificationSelections
                    "
                    [formGroup]="background"
                    [selections]="selectiveServiceNotificationSelections"
                    [control]="selectiveServiceNotificationSelectionId"
                    formControlName="selectiveServiceNotificationSelectionId"
                    [label]="
                        t(
                            'shared.radio-checkbox-group.selective-service-notification'
                        )
                    "
                    [requiredMessage]="
                        t(
                            'shared.error.required.selective-service-notification'
                        )
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>
        </div>

        <!-- Labor Force and Work Status fields replaced by Employment Status -->
        <div *ngIf="false">
            <mat-divider></mat-divider>
            <app-single-selection-control
                *ngIf="
                    laborForceStatusSelections$
                        | async as laborForceStatusSelections
                "
                [formGroup]="background"
                [selections]="laborForceStatusSelections"
                [control]="laborForceStatusSelectionId"
                formControlName="laborForceStatusSelectionId"
                [header]="t('shared.group.work-status')"
                [label]="t('shared.radio-checkbox-group.labor-force')"
                [requiredMessage]="t('shared.error.required.ethnicity')"
                [formSubmitted]="ngForm.submitted"
            ></app-single-selection-control>

            <app-single-selection-control
                *ngIf="workStatusSelections$ | async as workStatusSelections"
                [formGroup]="background"
                [selections]="workStatusSelections"
                [control]="workStatusSelectionId"
                formControlName="workStatusSelectionId"
                [label]="t('shared.radio-checkbox-group.work-status')"
                [requiredMessage]="t('shared.error.required.work-status')"
                [formSubmitted]="ngForm.submitted"
            ></app-single-selection-control>
        </div>

        <!-- EMPLOYMENT STATUS -->
        <div
            class="flyout-container"
            *ngIf="
                employmentStatusSelectionId ||
                employmentStatusAltSelectionId ||
                employmentStatusTerseSelectionId
            "
        >
            <mat-divider></mat-divider>

            <h3>{{ t("shared.group.employment-status") }}</h3>

            <div *ngIf="employmentStatusSelectionId">
                <app-single-selection-control
                    *ngIf="
                        employmentStatusSelections$
                            | async as employmentStatusSelections
                    "
                    [formGroup]="background"
                    [selections]="employmentStatusSelections"
                    [control]="employmentStatusSelectionId"
                    formControlName="employmentStatusSelectionId"
                    [label]="t('shared.radio-checkbox-group.employment-status')"
                    [requiredMessage]="
                        t('shared.error.required.employment-status')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div *ngIf="employmentStatusAltSelectionId">
                <app-single-selection-control
                    *ngIf="
                        employmentStatusAltSelections$
                            | async as employmentStatusAltSelections
                    "
                    [formGroup]="background"
                    [selections]="employmentStatusAltSelections"
                    [control]="employmentStatusAltSelectionId"
                    formControlName="employmentStatusAltSelectionId"
                    [label]="t('shared.radio-checkbox-group.employment-status')"
                    [requiredMessage]="
                        t('shared.error.required.employment-status')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div *ngIf="employmentStatusTerseSelectionId">
                <app-single-selection-control
                    *ngIf="
                        employmentStatusTerseSelections$
                            | async as employmentStatusTerseSelections
                    "
                    [formGroup]="background"
                    [selections]="employmentStatusTerseSelections"
                    [control]="employmentStatusTerseSelectionId"
                    formControlName="employmentStatusTerseSelectionId"
                    [label]="t('shared.radio-checkbox-group.employment-status')"
                    [requiredMessage]="
                        t('shared.error.required.employment-status')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div
                *ngIf="employer || occupation"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <!-- EMPLOYER -->
                <div
                    *ngIf="employer"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>
                            {{ t("shared.field.employer") }}
                        </mat-label>
                        <input
                            matInput
                            formControlName="employer"
                            [autocomplete]="'employer' | autocomplete"
                            maxlength="50"
                            [required]="employer.hasError('required')"
                        />
                        <mat-error *ngIf="employer?.hasError('required')">
                            {{ t("shared.error.required.employer") }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- OCCUPATION -->
                <div
                    *ngIf="occupation"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>
                            {{ t("shared.field.occupation") }}
                        </mat-label>
                        <input
                            matInput
                            formControlName="occupation"
                            [autocomplete]="'occupation' | autocomplete"
                            maxlength="100"
                            [required]="occupation.hasError('required')"
                        />
                        <mat-error *ngIf="occupation?.hasError('required')">
                            {{ t("shared.error.required.occupation") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- REGISTERED WITH WYOMING AT WORK -->
            <div *ngIf="registeredWithEmploymentAgencySelectionId">
                <app-single-selection-control
                    *ngIf="
                        registeredWithEmploymentAgencySelections$
                            | async as registeredWithEmploymentAgencySelections
                    "
                    [formGroup]="background"
                    [selections]="registeredWithEmploymentAgencySelections"
                    [control]="registeredWithEmploymentAgencySelectionId"
                    formControlName="registeredWithEmploymentAgencySelectionId"
                    [label]="t('shared.radio-checkbox-group.registered-waw')"
                    [requiredMessage]="
                        t('shared.error.required.registered-waw')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.employment-status').length === 0
                }"
            >
                <mat-card-content *ngIf="employmentStatusSelectionId">
                    <ng-container
                        *ngFor="let trans of t('flyout.employment-status')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
                <mat-card-content *ngIf="employmentStatusAltSelectionId">
                    <ng-container
                        *ngFor="let trans of t('flyout.employment-status-alt')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
                <mat-card-content *ngIf="employmentStatusTerseSelectionId">
                    <ng-container
                        *ngFor="
                            let trans of t('flyout.employment-status-terse')
                        "
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- PUBLIC ASSISTANCE -->
        <div
            class="flyout-container"
            *ngIf="receivingPublicAssistanceSelectionIds"
        >
            <mat-divider></mat-divider>
            <app-multi-selection-control
                *ngIf="
                    receivingPublicAssistanceSelections$
                        | async as receivingPublicAssistanceSelections
                "
                [formGroup]="background"
                [selections]="receivingPublicAssistanceSelections"
                [control]="receivingPublicAssistanceSelectionIds"
                formControlName="receivingPublicAssistanceSelectionIds"
                [header]="t('shared.group.public-assistance')"
                [label]="t('shared.radio-checkbox-group.public-assistance')"
                [requiredMessage]="
                    t('shared.error.required.receiving-public-assistance')
                "
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>
            <mat-error
                *ngIf="background?.hasError('publicAssistanceInvalid')"
                style="margin-bottom: 20px"
                >{{ t("shared.error.required.public-assistance-invalid") }}
            </mat-error>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.public-assistance').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.public-assistance')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- WIOA PARTERN PROGRAMS -->
        <div class="flyout-container" *ngIf="wioaPartnerProgramSelectionIds">
            <mat-divider></mat-divider>
            <app-multi-selection-control
                *ngIf="
                    wioaPartnerProgramSelections$
                        | async as wioaPartnerProgramSelections
                "
                [formGroup]="background"
                [selections]="wioaPartnerProgramSelections"
                [control]="wioaPartnerProgramSelectionIds"
                formControlName="wioaPartnerProgramSelectionIds"
                [header]="t('shared.group.wioa-partner-programs')"
                [label]="t('shared.radio-checkbox-group.wioa-partner-programs')"
                [requiredMessage]="
                    t('shared.error.required.wioa-partner-programs')
                "
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.wioa-partner-programs').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.wioa-partner-programs')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- FAMILY INFO -->
        <div class="flyout-container" *ngIf="maritalStatusSelectionId">
            <mat-divider></mat-divider>

            <h3>
                {{ t("shared.group.family-info") }}
            </h3>

            <!-- MARITAL STATUS -->
            <div *ngIf="maritalStatusSelectionId">
                <app-single-selection-control
                    *ngIf="
                        maritalStatusSelections$
                            | async as maritalStatusSelections
                    "
                    [formGroup]="background"
                    [selections]="maritalStatusSelections"
                    [control]="maritalStatusSelectionId"
                    formControlName="maritalStatusSelectionId"
                    [label]="t('shared.radio-checkbox-group.marital-status')"
                    [requiredMessage]="
                        t('shared.error.required.marital-status')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- CHILDREN -->
            <div
                *ngIf="
                    childrenAges0To5 && childrenAges6To10 && childrenAges11To18
                "
            >
                <h4>
                    {{ t("shared.group.children-ages") }}
                </h4>

                <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayoutAlign="start center"
                >
                    <!-- CHILDREN AGES 0 to 5 -->
                    <div
                        fxFlex="33"
                        fxLayoutAlign="start center"
                        fxFlex.xs="100"
                        fxFlexFill
                    >
                        <mat-form-field appearance="outline">
                            <mat-label>{{
                                t("shared.field.children-0-to-5")
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="childrenAges0To5"
                                [autocomplete]="
                                    'childrenAges0To5' | autocomplete
                                "
                                type="number"
                                min="0"
                                max="100"
                                [required]="
                                    childrenAges0To5.hasError('required')
                                "
                            />
                            <mat-error
                                *ngIf="childrenAges0To5?.hasError('required')"
                            >
                                {{ t("shared.error.required.children-0-to-5") }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- CHILDREN AGES 6 to 10 -->
                    <div
                        fxFlex="33"
                        fxLayoutAlign="start center"
                        fxFlex.xs="100"
                        fxFlexFill
                    >
                        <mat-form-field appearance="outline">
                            <mat-label>{{
                                t("shared.field.children-6-to-10")
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="childrenAges6To10"
                                [autocomplete]="
                                    'childrenAges6To10' | autocomplete
                                "
                                type="number"
                                min="0"
                                max="100"
                                [required]="
                                    childrenAges6To10.hasError('required')
                                "
                            />
                            <mat-error
                                *ngIf="childrenAges6To10?.hasError('required')"
                            >
                                {{
                                    t("shared.error.required.children-6-to-10")
                                }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- CHILDREN AGES 11 to 18 -->
                    <div
                        fxFlex="33"
                        fxLayoutAlign="start center"
                        fxFlex.xs="100"
                        fxFlexFill
                    >
                        <mat-form-field appearance="outline">
                            <mat-label>{{
                                t("shared.field.children-11-to-18")
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="childrenAges11To18"
                                [autocomplete]="
                                    'childrenAges11To18' | autocomplete
                                "
                                type="number"
                                min="0"
                                max="100"
                                [required]="
                                    childrenAges11To18.hasError('required')
                                "
                            />
                            <mat-error
                                *ngIf="childrenAges11To18?.hasError('required')"
                            >
                                {{
                                    t("shared.error.required.children-11-to-18")
                                }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- MOTHER UNDER 17 -->
            <div *ngIf="motherUnder17SelectionId">
                <app-single-selection-control
                    *ngIf="
                        motherUnder17Selections$
                            | async as motherUnder17Selections
                    "
                    [formGroup]="background"
                    [selections]="motherUnder17Selections"
                    [control]="motherUnder17SelectionId"
                    formControlName="motherUnder17SelectionId"
                    [label]="t('shared.radio-checkbox-group.mother-under-17')"
                    [requiredMessage]="
                        t('shared.error.required.mother-under-17')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- CHILD CARE -->
            <div *ngIf="childDependentCareNeededSelectionId">
                <app-single-selection-control
                    *ngIf="
                        childDependentCareNeededSelections$
                            | async as childDependentCareNeededSelections
                    "
                    [formGroup]="background"
                    [selections]="childDependentCareNeededSelections"
                    [control]="childDependentCareNeededSelectionId"
                    formControlName="childDependentCareNeededSelectionId"
                    [label]="t('shared.radio-checkbox-group.child-dep-care')"
                    [requiredMessage]="
                        t('shared.error.required.child-dep-care')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- TRANSPORTATION -->
            <div *ngIf="transportationNeededSelectionId">
                <app-single-selection-control
                    *ngIf="
                        transportationNeededSelections$
                            | async as transportationNeededSelections
                    "
                    [formGroup]="background"
                    [selections]="transportationNeededSelections"
                    [control]="transportationNeededSelectionId"
                    formControlName="transportationNeededSelectionId"
                    [label]="t('shared.radio-checkbox-group.transportation')"
                    [requiredMessage]="
                        t('shared.error.required.transportation')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.family-info').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container *ngFor="let trans of t('flyout.family-info')">
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- FAMILY INCOME -->
        <div class="flyout-container" *ngIf="familyIncome">
            <mat-divider></mat-divider>

            <h3>
                {{ t("shared.group.family-income") }}
            </h3>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix>attach_money</mat-icon>
                        <mat-label>{{
                            t("shared.field.family-income")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="familyIncome"
                            [autocomplete]="'familyIncome' | autocomplete"
                            type="number"
                            min="0"
                            max="10000000"
                            oninput="value = !!value && value < 0 ? value*-1 : value"
                            [required]="familyIncome.hasError('required')"
                        />
                        <mat-error *ngIf="familyIncome?.hasError('required')">
                            {{ t("shared.error.required.family-income") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- INCOME PERIOD -->
            <div *ngIf="incomePeriodSelectionId">
                <app-single-selection-control
                    *ngIf="
                        incomePeriodSelections$
                            | async as incomePeriodSelections
                    "
                    [formGroup]="background"
                    [selections]="incomePeriodSelections"
                    [control]="incomePeriodSelectionId"
                    formControlName="incomePeriodSelectionId"
                    [requiredMessage]="t('shared.error.required.income-period')"
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.ethnicity').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.family-income')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- YOUR INCOME -->
        <div class="flyout-container" *ngIf="yourIncome">
            <mat-divider></mat-divider>

            <h3>
                {{ t("shared.group.your-income") }}
            </h3>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix>attach_money</mat-icon>
                        <mat-label>{{
                            t("shared.field.your-income")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="yourIncome"
                            [autocomplete]="'yourIncome' | autocomplete"
                            type="number"
                            min="0"
                            max="10000000"
                            oninput="value = !!value && value < 0 ? value*-1 : value"
                            [required]="yourIncome.hasError('required')"
                        />
                        <mat-error *ngIf="yourIncome?.hasError('required')">
                            {{ t("shared.error.required.your-income") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- INCOME PERIOD -->
            <div *ngIf="incomePeriodSelectionId">
                <app-single-selection-control
                    *ngIf="
                        incomePeriodSelections$
                            | async as incomePeriodSelections
                    "
                    [formGroup]="background"
                    [selections]="incomePeriodSelections"
                    [control]="incomePeriodSelectionId"
                    formControlName="incomePeriodSelectionId"
                    [requiredMessage]="t('shared.error.required.income-period')"
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.ethnicity').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container *ngFor="let trans of t('flyout.your-income')">
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- ELIGIBILITY -->
        <div
            class="flyout-container"
            *ngIf="
                eligibilityStatusSelectionId ||
                eligibilityCategorySelectionId ||
                eligibilityExplanation ||
                eligibilityConsentSelectionId
            "
        >
            <mat-divider></mat-divider>

            <h3>
                {{ t("shared.group.eligibility") }}
            </h3>

            <div *ngIf="eligibilityStatusSelectionId">
                <app-single-selection-control
                    *ngIf="
                        EligibilityStatusSelections$
                            | async as eligibilityStatusSelections
                    "
                    [formGroup]="background"
                    [selections]="eligibilityStatusSelections"
                    [control]="eligibilityStatusSelectionId"
                    formControlName="eligibilityStatusSelectionId"
                    [label]="t('shared.field.eligibility-status')"
                    [requiredMessage]="
                        t('shared.error.required.eligibility-status')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <div *ngIf="eligibilityCategorySelectionId">
                <app-single-selection-control
                    *ngIf="
                        EligibilityCategorySelections$
                            | async as EligibilityCategorySelections
                    "
                    [formGroup]="background"
                    [selections]="EligibilityCategorySelections"
                    [control]="eligibilityCategorySelectionId"
                    formControlName="eligibilityCategorySelectionId"
                    [label]="t('shared.field.eligibility-category')"
                    [requiredMessage]="
                        t('shared.error.required.eligibility-category')
                    "
                    [formSubmitted]="ngForm.submitted"
                    requiredFormControlName="eligibilityCategoryRequired"
                ></app-single-selection-control>
            </div>

            <div *ngIf="eligibilityExplanation">
                <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayoutAlign="start center"
                >
                    <div
                        fxFlex="100"
                        fxLayoutAlign="start center"
                        fxFlex.xs="100"
                        fxFlexFill
                    >
                        <h4>
                            {{ t("shared.field.eligibility-explanation")
                            }}{{
                                background.hasError(
                                    "eligibilityExplanationRequired"
                                )
                                    ? " *"
                                    : ""
                            }}
                        </h4>
                    </div>
                </div>
                <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayoutAlign="start center"
                >
                    <div
                        fxFlex="100"
                        fxLayoutAlign="start center"
                        fxFlex.xs="100"
                        fxFlexFill
                    >
                        <mat-form-field appearance="outline" class="full-width">
                            <input
                                matInput
                                formControlName="eligibilityExplanation"
                                maxlength="200"
                                [required]="eligibilityExplanationValidator()"
                            />
                            <mat-error
                                *ngIf="
                                    ((eligibilityExplanation &&
                                        eligibilityExplanation.touched) ||
                                        ngForm.touched) &&
                                    eligibilityExplanationValidator()
                                "
                            >
                                {{
                                    t(
                                        "shared.error.required.eligibility-explanation"
                                    )
                                }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div *ngIf="eligibilityConsentSelectionId">
                <app-single-selection-control
                    *ngIf="
                        EligibilityConsentSelections$
                            | async as eligibilityConsentSelections
                    "
                    [formGroup]="background"
                    [selections]="eligibilityConsentSelections"
                    [control]="eligibilityConsentSelectionId"
                    formControlName="eligibilityConsentSelectionId"
                    [label]="t('shared.field.eligibility-consent')"
                    [requiredMessage]="
                        t('shared.error.required.eligibility-consent')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>
        </div>

        <!-- IMMIGRATION INFO -->
        <div
            class="flyout-container"
            *ngIf="
                immigrationStatusSelectionId ||
                immigrantStatusSelectionId ||
                refugeeStatusSelectionId ||
                hasF1OrJ1VisaSelectionId ||
                countryOfOriginSelectionId
            "
        >
            <mat-divider></mat-divider>

            <h3>
                {{ t("shared.group.immigration-info") }}
            </h3>

            <!-- IMMIGRANT OR REFUGEE -->
            <div *ngIf="immigrationStatusSelectionId">
                <app-single-selection-control
                    *ngIf="
                        immigrationStatusSelections$
                            | async as immigrationStatusSelections
                    "
                    [formGroup]="background"
                    [selections]="immigrationStatusSelections"
                    [control]="immigrationStatusSelectionId"
                    formControlName="immigrationStatusSelectionId"
                    [label]="t('shared.radio-checkbox-group.immigration-info')"
                    [requiredMessage]="
                        t('shared.error.required.immigration-status')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- IMMIGRANT -->
            <div *ngIf="immigrantStatusSelectionId">
                <app-single-selection-control
                    *ngIf="
                        immigrantStatusSelections$
                            | async as immigrantStatusSelections
                    "
                    [formGroup]="background"
                    [selections]="immigrantStatusSelections"
                    [control]="immigrantStatusSelectionId"
                    formControlName="immigrantStatusSelectionId"
                    [label]="t('shared.radio-checkbox-group.immigrant')"
                    [requiredMessage]="t('shared.error.required.immigrant')"
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- REFUGEE -->
            <div *ngIf="refugeeStatusSelectionId">
                <app-single-selection-control
                    *ngIf="
                        refugeeStatusSelections$
                            | async as refugeeStatusSelections
                    "
                    [formGroup]="background"
                    [selections]="refugeeStatusSelections"
                    [control]="refugeeStatusSelectionId"
                    formControlName="refugeeStatusSelectionId"
                    [label]="t('shared.radio-checkbox-group.refugee')"
                    [requiredMessage]="t('shared.error.required.refugee')"
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- F1 OR J1 VISA -->
            <div *ngIf="hasF1OrJ1VisaSelectionId">
                <app-single-selection-control
                    *ngIf="
                        hasF1OrJ1VisaSelections$
                            | async as hasF1OrJ1VisaSelections
                    "
                    [formGroup]="background"
                    [selections]="hasF1OrJ1VisaSelections"
                    [control]="hasF1OrJ1VisaSelectionId"
                    formControlName="hasF1OrJ1VisaSelectionId"
                    [label]="t('shared.radio-checkbox-group.has-f1-or-j1-visa')"
                    [requiredMessage]="
                        t('shared.error.required.has-f1-or-j1-visa')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- COUNTRY OF ORIGIN -->
            <div
                *ngIf="countryOfOriginSelectionId"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{
                            t("shared.field.country-of-origin")
                        }}</mat-label>
                        <mat-select
                            formControlName="countryOfOriginSelectionId"
                            [required]="
                                countryOfOriginSelectionId.hasError('required')
                            "
                            #countryOfOriginSelection
                        >
                            <mat-option>
                                <ngx-mat-select-search
                                    [formControl]="filterCountryOfOriginCtrl"
                                    [placeholderLabel]="
                                        t('shared.search-select.search')
                                    "
                                    [noEntriesFoundLabel]="
                                        t(
                                            'shared.search-select.no-entries-found'
                                        )
                                    "
                                    [clearSearchInput]="false"
                                ></ngx-mat-select-search>
                            </mat-option>

                            <mat-option
                                *ngFor="
                                    let selection of filteredCountryOfOriginSelections
                                        | async
                                "
                                [value]="selection.selectionId"
                            >
                                {{ selection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                (countryOfOriginSelectionId?.touched ||
                                    ngForm.submitted) &&
                                countryOfOriginSelectionId?.hasError('required')
                            "
                        >
                            {{ t("shared.error.required.country-of-origin") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.immigration-info').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.immigration-info')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- DISABILITY-->
        <div class="flyout-container" *ngIf="disabilitySelectionId">
            <mat-divider></mat-divider>

            <!-- DISABILITY-->
            <app-single-selection-control
                *ngIf="disabilitySelections$ | async as disabilitySelections"
                [formGroup]="background"
                [selections]="disabilitySelections"
                [control]="disabilitySelectionId"
                formControlName="disabilitySelectionId"
                [header]="t('shared.group.disability')"
                [label]="t('shared.radio-checkbox-group.disability')"
                [requiredMessage]="t('shared.error.required.disability')"
                [formSubmitted]="ngForm.submitted"
            ></app-single-selection-control>

            <!-- DISABILITY DOCUMENTED -->
            <div *ngIf="disabilityDocumentedSelectionId">
                <app-single-selection-control
                    *ngIf="
                        disabilityDocumentedSelections$
                            | async as disabilityDocumentedSelections
                    "
                    [formGroup]="background"
                    [selections]="disabilityDocumentedSelections"
                    [control]="disabilityDocumentedSelectionId"
                    formControlName="disabilityDocumentedSelectionId"
                    [label]="
                        t('shared.radio-checkbox-group.disability-documented')
                    "
                    [requiredMessage]="
                        t('shared.error.required.disability-documented')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <!-- DISABILITY ACCOMMODATION -->
            <div *ngIf="disabilityAccommodationsSelectionId">
                <app-single-selection-control
                    *ngIf="
                        disabilityAccommodationsSelections$
                            | async as disabilityAccommodationsSelections
                    "
                    [formGroup]="background"
                    [selections]="disabilityAccommodationsSelections"
                    [control]="disabilityAccommodationsSelectionId"
                    formControlName="disabilityAccommodationsSelectionId"
                    [label]="
                        t(
                            'shared.radio-checkbox-group.disability-accommodations'
                        )
                    "
                    [requiredMessage]="
                        t('shared.error.required.disability-accommodations')
                    "
                    [formSubmitted]="ngForm.submitted"
                ></app-single-selection-control>
            </div>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip height-auto"
                [ngClass]="{
                    hidden: t('flyout.disability').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container *ngFor="let trans of t('flyout.disability')">
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- REFERRAL SOURCE -->
        <div class="flyout-container" *ngIf="referralSourceSelectionId">
            <mat-divider></mat-divider>

            <h3>
                {{ t("shared.group.referral-source") }}
            </h3>

            <!-- REFERRED TO PROGRAM BY -->
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            referralSourceSelections$
                                | async as referralSourceSelections
                        "
                    >
                        <mat-label>{{ t("shared.field.referral") }}</mat-label>
                        <mat-select
                            formControlName="referralSourceSelectionId"
                            [required]="
                                referralSourceSelectionId.hasError('required')
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let referralSourceSelection of referralSourceSelections
                                "
                                [value]="referralSourceSelection.selectionId"
                            >
                                {{ referralSourceSelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                referralSourceSelectionId?.hasError('required')
                            "
                        >
                            {{ t("shared.error.required.referral-source") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <!-- REFERRAL ORGANIZATION NAME -->
                <div
                    *ngIf="referralOrganizationName"
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.referral-organization-name")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="referralOrganizationName"
                            [autocomplete]="
                                'referralOrganizationName' | autocomplete
                            "
                            maxlength="100"
                            [required]="
                                referralOrganizationName.hasError('required')
                            "
                        />
                        <mat-error
                            *ngIf="
                                referralOrganizationName?.hasError('required')
                            "
                        >
                            {{
                                t(
                                    "shared.error.required.referral-organization-name"
                                )
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <!-- REFERRAL NAME -->
                <div
                    *ngIf="referralContactName"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.referral-name")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="referralContactName"
                            [autocomplete]="
                                'referralContactName' | autocomplete
                            "
                            maxlength="100"
                            [required]="
                                referralContactName.hasError('required')
                            "
                        />
                        <mat-error
                            *ngIf="referralContactName?.hasError('required')"
                        >
                            {{
                                t("shared.error.required.referral-contact-name")
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- REFERRAL PHONE -->
                <div
                    *ngIf="referralContactPhone"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.referral-phone")
                        }}</mat-label>
                        <app-phone-input
                            formControlName="referralContactPhone"
                            #phone
                            [required]="
                                referralContactPhone.hasError('required')
                            "
                        ></app-phone-input>
                        <mat-error
                            *ngIf="
                                (referralContactPhone?.touched ||
                                    ngForm.submitted) &&
                                referralContactPhone?.hasError('pattern')
                            "
                            >{{ t("shared.error.pattern.phone") }}</mat-error
                        >
                        <mat-error
                            *ngIf="referralContactPhone?.hasError('required')"
                        >
                            {{
                                t(
                                    "shared.error.required.referral-contact-phone"
                                )
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.referral-source').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.referral-source')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <button
            mat-stroked-button
            class="submit"
            type="submit"
            [disabled]="submitting"
        >
            {{ t("application.save-and-continue") }}
        </button>
    </form>
</ng-container>
